






























































import { computed, defineComponent, onMounted, ref } from "@vue/composition-api";
import { isAudioFile, isImageFile, isVideoFile } from "@/lib/fileHelpers";
import AudioPlayerController from "@/components/AudioPlayerController";
import BaseIcon from "@/components/BaseIcon";
import BaseIconButton from "@/components/BaseIconButton";
import BaseImage from "@/components/BaseImage";
import { pauseGlobalPlayer } from "@/components/GlobalAudioPlayer/helpers";
import PlayButton from "@/components/PlayButton";

export default defineComponent({
  name: "UploadedFileItem",
  components: { BaseIconButton, BaseIcon, AudioPlayerController, PlayButton, BaseImage },
  props: {
    file: { type: File, required: true },
  },
  setup(props, { emit }) {
    const player = ref<HTMLVideoElement>();
    const videoSource = ref();
    const isVideoPlaying = ref(false);
    const mediaSrc = ref("");
    const imageSrc = ref("");
    const isVideo = computed(() => isVideoFile(props.file));
    const isImage = computed(() => isImageFile(props.file));
    const isAudio = computed(() => isAudioFile(props.file));
    const getAudioVideoSrc = (file: File) => {
      const newObjectUrl = URL.createObjectURL(file) as string;
      const oldObjectUrl = mediaSrc.value;
      if (oldObjectUrl && oldObjectUrl.startsWith("blob:")) {
        mediaSrc.value = "";
        URL.revokeObjectURL(oldObjectUrl);
      }
      mediaSrc.value = newObjectUrl;
    };
    const getImageSrc = (imageFile: File) => {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(imageFile);
      fileReader.onload = event => {
        if (event && event.target) {
          imageSrc.value = event.target.result as string;
        }
      };
    };

    const onPlayPause = (status: boolean) => {
      isVideoPlaying.value = status;
    };

    const playVideo = () => {
      player.value?.play();
      pauseGlobalPlayer();
    };

    onMounted(() => {
      if (isImage.value) {
        getImageSrc(props.file);
      }
      if (isVideo.value) {
        getAudioVideoSrc(props.file);
        player.value?.addEventListener(
          "loadedmetadata",
          () => {
            player.value && emit("fileDuration", { name: props.file.name, duration: player.value?.duration * 1000 });
          },
          { once: true }
        );
        player.value?.load();
      }
      if (isAudio.value) {
        getAudioVideoSrc(props.file);
      }
    });
    return {
      player,
      videoSource,
      isVideo,
      isImage,
      imageSrc,
      isAudio,
      mediaSrc,
      isVideoPlaying,
      playVideo,
      onPlayPause,
    };
  },
});
